export const CleanAdminSession = () => {
    sessionStorage.removeItem('id');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('date');
    return;
}